module.exports = __webpack_public_path__ + "media/images/symbols/white-caret-right-b8bcc392427e32f61056fc29cfd2d053.svg";